import { lazyWithPreload } from 'helpers/lazyWithPreload'

export const PurchaseIntroOffer = lazyWithPreload(
  () => import('./PurchaseIntroOffer'),
)
